// extracted by mini-css-extract-plugin
module.exports = {"poweredCon":"style_poweredCon__1CpWq","text":"style_text__32b-D","poweredImg":"style_poweredImg__E4sY3"};